import { ReactElement, useEffect, useState } from 'react'
import { Table } from 'bd-web-components'
import { monthlyColumns } from '../../../utils/advance-analytics-table'
import {
  useGetLast6MonthAdvanceTefData,
  useGetLast6MonthAdvanceWebData,
} from '../../../hooks/advanced-analytics-v2'
import Loader from '../../../components/Loader'
import { TitleChart } from './styles'

type Row = { month: string }

export function sortByMonth<T extends Row>(
  arr: T[],
  order: 'asc' | 'desc' = 'asc'
): T[] {
  const re = /^\d{4}-\d{2}$/
  return [...arr].sort((a, b) => {
    if (!re.test(a.month) || !re.test(b.month))
      throw new Error('month must be yyyy-MM')
    return order === 'asc'
      ? a.month.localeCompare(b.month)
      : b.month.localeCompare(a.month)
  })
}

export function AnalyticsTableWeb(): ReactElement {
  const [data, setData] = useState<any>(null)

  const {
    last6MonthWebData,
    last6MonthWebDataLoading,
    last6MonthWebDataError,
  } = useGetLast6MonthAdvanceWebData()

  useEffect(() => {
    if (last6MonthWebData !== undefined) {
      console.log('web', last6MonthWebData)
      setData(sortByMonth(last6MonthWebData, 'desc'))
    }
  }, [last6MonthWebData, last6MonthWebDataLoading, last6MonthWebDataError])
  return (
    <>
      {data !== null && (
        <>
          <TitleChart>Origem WEB: Ultimos 6 meses </TitleChart>
          <br />
          <Table columns={monthlyColumns('web')} data={data} pageCount={0} />
        </>
      )}
      {last6MonthWebDataLoading && (
        <div
          style={{
            height: '600px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Loader />
        </div>
      )}
      {last6MonthWebDataError && !last6MonthWebDataLoading && (
        <div
          style={{
            height: '600px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          Um erro aconteceu, tente novamente!
        </div>
      )}
    </>
  )
}
export function AnalyticsTableTef(): ReactElement {
  const [data, setData] = useState<any>(null)

  const {
    last6MonthTefData,
    last6MonthTefDataLoading,
    last6MonthTefDataError,
  } = useGetLast6MonthAdvanceTefData()

  useEffect(() => {
    if (last6MonthTefData !== undefined) {
      console.log('TEF', last6MonthTefData)
      setData(sortByMonth(last6MonthTefData, 'desc'))
    }
  }, [last6MonthTefData, last6MonthTefDataLoading, last6MonthTefDataError])
  return (
    <>
      {data !== null && (
        <>
          <TitleChart>Origem TEF: Ultimos 6 meses </TitleChart>
          <br />
          <Table columns={monthlyColumns('tef')} data={data} pageCount={0} />
        </>
      )}
      {last6MonthTefDataLoading && (
        <div
          style={{
            height: '600px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Loader />
        </div>
      )}
      {last6MonthTefDataError && !last6MonthTefDataLoading && (
        <div
          style={{
            height: '600px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          Um erro aconteceu, tente novamente!
        </div>
      )}
    </>
  )
}
